import React from 'react'
import './student-onboarding-card-modal-2023.css'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { taskCardAnimateIn, taskCardAnimateOut, freshSubtask } from '../../AdminTasks/adminTaskUtils'
import TaskCardSettingBar from '../../TaskCardModal2023/TaskCardSettingBar/TaskCardSettingBar'
import LooksLikeYouAreDonePopup from '../../WorfklowCardModal2023/LooksLikeYouAreDonePopup/LooksLikeYouAreDonePopup'
import Subtask2023 from '../../TaskCardModal2023/Subtask2023/Subtask2023'
import WebsiteInquiryCallSwitch from '../WebsiteInquiryCardModal2023/WebsiteInquryCallSwitch/WebsiteInquiryCallSwitch'
import { differenceInDays, setDay } from 'date-fns'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const StudentOnboardingCardModal2023 = ({openWorkflowModal2023, setOpenWorkflowModal2023, setWorkflows, setShowNotes, closeTheStudentOnboardingModal, signalWorkflowBeingDeleted}) => {
    const [isPopupOpen, setIsPopupOpen] = React.useState(false)
    const [showDescription, setShowDescription] = React.useState(false)
    const [teacherList, setTeacherList] = React.useState([])
    const [instList, setInstList] = React.useState([])
    const [daysToOnboard, setDaysToOnboard] = React.useState('')
    React.useEffect(() => {
        taskCardAnimateIn('student-onboarding-card-modal-2023__wrapper', 'student-onboarding-card-modal-2023')
        getTeachers()
        getInstruments()
        getAndCalculateOnboardDateAndDuration()
    }, [])
    React.useEffect(() => setTheTabs())

    React.useEffect(() => {
        getTeachers()
    }, [openWorkflowModal2023.whichSchool])

    const checkForAutoClear = (val) => {
        val === "New Task..." && setOpenWorkflowModal2023({...openWorkflowModal2023, todoName: ''})
    }

    const getTeachers = () => {
        axios.get(`${baseUrl}/rawteacherdata/${openWorkflowModal2023.whichSchool}`)
        .then((res) => setTeacherList(res.data))
        .catch((err) => console.log(err))
    }

    const getInstruments = () => {
        axios.get(`${baseUrl}/inst`)
        .then((res) => setInstList(res.data))
        .catch((err) => console.log(err))
    }

    const getAndCalculateOnboardDateAndDuration = () => {
        if(openWorkflowModal2023.familyId === 'none' || !openWorkflowModal2023.familyId) {

        } else {
            axios.get(`${baseUrl}/school-management/${openWorkflowModal2023.familyId}`).then((res) => {
                setDaysToOnboard(differenceInDays(new Date(), new Date(res.data.onboardDate)))
            })
            .catch((err) => console.log(err))
        }
    }

    const setTheTabs = () => {
        if(document.getElementById('modal-view-tasks') && document.getElementById('modal-view-description')) {
            if(showDescription === false) {
                document.getElementById('modal-view-tasks').style.borderBottom = "2px solid #000"
                document.getElementById('modal-view-tasks').style.color = "#000"
                document.getElementById('modal-view-description').style.borderBottom = "1px solid rgb(146, 146, 146)"
                document.getElementById('modal-view-description').style.color = "rgb(146, 146, 146)"
            } else {
                document.getElementById('modal-view-tasks').style.borderBottom = "1px solid rgb(146, 146, 146)"
                document.getElementById('modal-view-tasks').style.color = "rgb(146, 146, 146)"
                document.getElementById('modal-view-description').style.borderBottom = "2px solid #000"
                document.getElementById('modal-view-description').style.color = "#000"
            }
        }
    }

    const saveAndCloseTask = () => {
        setShowNotes(false)
        taskCardAnimateOut('student-onboarding-card-modal-2023__wrapper', 'student-onboarding-card-modal-2023')
        axios.put(`${baseUrl}/student-onboarding/${openWorkflowModal2023.todoId}`, openWorkflowModal2023, myHeader)
        .then((res) => {
            closeTheStudentOnboardingModal(res.data)
            setWorkflows(prev => (prev.map((todo) => todo.todoId === res.data.todoId ? res.data : todo)))
            setOpenWorkflowModal2023(false)
        })
        .catch((err) => console.log(err))
    }

    const deleteAndCloseTask = () => {
        setShowNotes(false)
        taskCardAnimateOut('student-onboarding-card-modal-2023__wrapper', 'student-onboarding-card-modal-2023')
        axios.delete(`${baseUrl}/student-onboarding/${openWorkflowModal2023.todoId}`, myHeader)
        .then((res) => {
            signalWorkflowBeingDeleted(res.data.todoId)
            setWorkflows(prev => (prev.filter((todo) => todo.todoId !== res.data.todoId && todo)))
            setOpenWorkflowModal2023(false)
        })
        .catch((err) => console.log(err))
    }

    const removeStudent = (id) => {
        let updatedList = openWorkflowModal2023.studentList
        for(let i = 0; i < updatedList.length; i++) {
            if(updatedList[i].studentId === id) {
                updatedList.splice(i, 1)
            }
        }
        setOpenWorkflowModal2023({...openWorkflowModal2023, studentList: updatedList})
    }

    const editStudent = (id, value, theKey, secondKey) => {
        let updatedList = openWorkflowModal2023.studentList
        for(let i = 0; i < updatedList.length; i++) {
            if(updatedList[i].studentId === id) {
                if(secondKey) {
                    secondKey === 'date' ? updatedList[i].introLesson[secondKey] = value : updatedList[i].introLesson[secondKey] = value
                } else {
                    updatedList[i][theKey] = value
                }
            }
        }
        setOpenWorkflowModal2023({...openWorkflowModal2023, studentList: updatedList})
    }

    const removeInstFromStudent = (stuId, instId) => {
        let updatedList = openWorkflowModal2023.studentList
        for(let i = 0; i < updatedList.length; i++) {
            if(updatedList[i].studentId === stuId) {
                for(let j = 0; j < updatedList[i].instrumentList.length; j++) {
                    if(updatedList[i].instrumentList[j].id === instId) {
                        updatedList[i].instrumentList.splice(j, 1)
                    }
                }
            }
        }
        setOpenWorkflowModal2023({...openWorkflowModal2023, studentList: updatedList})
    }

    const addInstToStudent = (stuId, instId) => {
        let updatedList = openWorkflowModal2023.studentList
        for(let i = 0; i < instList.length; i++) {
            if(instList[i].id === instId) {
                for(let j = 0; j < updatedList.length; j++) {
                    if(updatedList[j].studentId === stuId) {
                        updatedList[j].instrumentList.push(instList[i])
                    }
                }
            }
        }
        setOpenWorkflowModal2023({...openWorkflowModal2023, studentList: updatedList})
        document.getElementById('admin-modal__student-list__inst-input').value = ''
    }

    const addTeacherToStudent = (id, name) => {
        let updatedList = openWorkflowModal2023.studentList
        for(let i = 0; i < teacherList.length; i++) {
            if(name === teacherList[i].Name) {
                for(let j = 0; j < updatedList.length; j++) {
                    if(id === updatedList[j].studentId) {
                        updatedList[j].teacherList.push({
                            TeacherID: teacherList[i].TeacherID,
                            Name: teacherList[i].Name,
                            ImageName: teacherList[i].ImageName
                        })
                    }
                }
            }
        }
        setOpenWorkflowModal2023({...openWorkflowModal2023, studentList: updatedList})
        document.getElementById('admin-modal__student-list__teacher-input').value = ''
    }

    const removeTeacherFromStudent = (studentId, id) => {
        let updatedList = openWorkflowModal2023.studentList
        for(let i = 0; i < updatedList.length; i++) {
            if(studentId === updatedList[i].studentId) {
                for(let j = 0; j < updatedList[i].teacherList.length; j++) {
                    if(id === updatedList[i].teacherList[j].TeacherID) {
                        updatedList[i].teacherList.splice(j, 1)
                    }
                }
            }
        }
        setOpenWorkflowModal2023({...openWorkflowModal2023, studentList: updatedList})
    }

    const changeAlarm = (b) => {
        setOpenWorkflowModal2023({...openWorkflowModal2023, todoAlarm: b})
    }

    const changeTheyHaveBeenCalled = (b) => {
        setOpenWorkflowModal2023({...openWorkflowModal2023, theyHaveBeenCalled: b})
    }

    const addStudent = () => {
        let updatedList = openWorkflowModal2023.studentList ? openWorkflowModal2023.studentList : []
        updatedList.push({
            studentId: Math.random().toString(16).slice(2),
            studentName: 'Student Name',
            instrumentList: [],
            teacherList: [],
            introLesson: {
              date: '',
              isScheduled: false,
              hasBeenCalled: false
            },
          })
          setOpenWorkflowModal2023({...openWorkflowModal2023, studentList: updatedList})
    }

    let finalDateFormat = ''
    let currentDueDate = openWorkflowModal2023.todoDueDate
    function createDate() {
        let todaysDate = new Date(currentDueDate)
        let theMonth = ''
        let todaysMonth = todaysDate.getMonth() + 1
        if(todaysMonth < 10) {
            theMonth = `0${todaysMonth}`
        } else {
            theMonth = todaysMonth
        }
        let theDay = ''
        if(todaysDate.getDate() < 10) {
            theDay = `0${todaysDate.getDate()}`
        } else {
            theDay = todaysDate.getDate()
        }
        finalDateFormat = `${todaysDate.getFullYear()}-${theMonth}-${theDay}T10:00:00`
    }
    createDate()

    return(
        <div className='student-onboarding-card-modal-2023__wrapper' id='student-onboarding-card-modal-2023__wrapper' onClick={(e) => e.target.id === 'student-onboarding-card-modal-2023__wrapper' && (openWorkflowModal2023.todoSubtasks.filter((sub) => !sub.subtaskCompleted && sub).length > 0 ? saveAndCloseTask() : setIsPopupOpen(true))}>
            {isPopupOpen && <LooksLikeYouAreDonePopup saveAndCloseTask={saveAndCloseTask} deleteAndCloseTask={deleteAndCloseTask} />}
            <div className='student-onboarding-card-modal-2023' id='student-onboarding-card-modal-2023'>
                {parseInt(daysToOnboard) !== 0 && daysToOnboard && <div className='student-onboarding-card-modal-2023__days-to-onboard'>Onboarding for {parseInt(daysToOnboard) === 0 && 'hi'} days</div>}
                <input className='student-onboarding-card-modal-2023__task-name' value={openWorkflowModal2023.todoName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => setOpenWorkflowModal2023({...openWorkflowModal2023, todoName: e.target.value})} />
                <TaskCardSettingBar openModal2023={openWorkflowModal2023} setOpenModal2023={setOpenWorkflowModal2023} />
                <div className="student-onboarding-card-modal-2023__two-sections-divider">
                    <div className="student-onboarding-card-modal-2023__modal-view-tabs" id="modal-view-tasks" onClick={() => setShowDescription(false)}>Tasks</div>
                    <div className="student-onboarding-card-modal-2023__modal-view-tabs" id="modal-view-description" onClick={() => setShowDescription(true)}>Intro Lesson(s)</div>
                </div>
                {showDescription ?
                    <div className='admin-modal-desc__inst-area'>
                                        {openWorkflowModal2023.studentList && 
                                            <div className='admin-modal__student-area'>
                                                {openWorkflowModal2023.studentList.map((student) => (
                                                    <div key={student.studentId} className='admin-modal__student-list__row'>
                                                        <div>
                                                            <div className='admin-modal__inst-list__chip__x' onClick={() => removeStudent(student.studentId)}>x</div>
                                                        </div>
                                                        <div className='admin-modal__student-list__info'>
                                                            <input className='admin-modal__student-list__name-input' value={student.studentName} onChange={(e) => editStudent(student.studentId, e.target.value, 'studentName')} />
                                                            {student.introLesson.isScheduled && <input type="datetime-local" className="admin-modal__student-list__date-input" placeholder='yyyy-mm-ddT00:00' defaultValue={finalDateFormat} value={student.introLesson.date} onChange={(e) => editStudent(student.studentId, e.target.value, 'introLesson', 'date')}></input>}
                                                            <div className='admin-modal__student-list__instrument-list__wrapper'>
                                                                {student.instrumentList.map((inst) => (
                                                                    <div key={inst.id} className="admin-modal__student-list__instrument-list__inst-card" >
                                                                        <div className="admin-modal__student-list__instrument-list__inst-card__name">{inst.name}</div>
                                                                        <div className="admin-modal__student-list__instrument-list__inst-card__remove" onClick={() => removeInstFromStudent(student.studentId, inst.id)}>x</div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className='admin-modal__student-list__add-wrapper'>
                                                                <select className='admin-modal__student-list__teacher-input' id='admin-modal__student-list__teacher-input' onChange={(e) => addTeacherToStudent(student.studentId, e.target.value)}>
                                                                    <option value=''>Add Teacher</option>
                                                                    { teacherList.length > 0 ? teacherList.map((teacher) => (
                                                                        <option key={teacher.TeacherID} value={teacher.Name}>{teacher.Name}</option>
                                                                    ))
                                                                    :
                                                                    <option>Choose School on Card</option>
                                                                    }
                                                                </select>
                                                                <select className='admin-modal__student-list__teacher-input' id='admin-modal__student-list__inst-input' onChange={(e) => addInstToStudent(student.studentId, e.target.value)}>
                                                                    <option value=''>Add Instrument</option>
                                                                    {instList.map((inst) => (
                                                                        <option key={inst.id} value={inst.id}>{inst.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className='admin-modal__student-list__all-switches'>
                                                                <div className='admin-modal__student-list__switch-wrapper'>
                                                                    <div className='admin-modal__student-list__switch-label'>Intro Scheduled</div>
                                                                    {student.introLesson.isScheduled ? 
                                                                        <svg cursor="pointer" onClick={() => editStudent(student.studentId, false, 'introLesson', 'isScheduled')} className="admin-modal__student-list__switch-svg" viewBox="0 0 512 512">
                                                                            <g>
                                                                                <g>
                                                                                    <path fill="green" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                                                                        S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                                                                                        c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                        : 
                                                                        <svg cursor="pointer" onClick={() => editStudent(student.studentId, true, 'introLesson', 'isScheduled')} className="admin-modal__student-list__switch-svg" viewBox="0 0 511.999 511.999">
                                                                            <g>
                                                                                <g>
                                                                                    <path fill="rgba(150, 150, 150, 1)" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                                                                        S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                                                                                        c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                    } 
                                                                </div>
                                                                <div className='admin-modal__student-list__switch-wrapper'>
                                                                    <div className='admin-modal__student-list__switch-label'>Family Called</div>
                                                                    {student.introLesson.hasBeenCalled ? 
                                                                        <svg cursor="pointer" onClick={() => editStudent(student.studentId, false, 'introLesson', 'hasBeenCalled')} className="admin-modal__student-list__switch-svg" viewBox="0 0 512 512">
                                                                            <g>
                                                                                <g>
                                                                                    <path fill="green" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                                                                        S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                                                                                        c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                        : 
                                                                        <svg cursor="pointer" onClick={() => editStudent(student.studentId, true, 'introLesson', 'hasBeenCalled')} className="admin-modal__student-list__switch-svg" viewBox="0 0 511.999 511.999">
                                                                            <g>
                                                                                <g>
                                                                                    <path fill="rgba(150, 150, 150, 1)" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                                                                        S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                                                                                        c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                    } 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='admin-modal__student-list__teachers'>
                                                            {student.teacherList.map((teacher) => (
                                                                <div key={teacher.TeacherID} className='admin-modal__teacher-list__card'>
                                                                    <div className='admin-modal__teacher-list__remove-teacher' onClick={() => removeTeacherFromStudent(student.studentId, teacher.TeacherID)}>x</div>
                                                                    <img alt='teacher-card' className='admin-modal__teacher-list__image' src={`https://app.atharo.app/images/${teacher.ImageName}`} />
                                                                    <div className='admin-modal__teacher-list__name'>{teacher.Name.split(' ')[0]}</div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )) }
                                            </div>
                                        }
                                        <div className='admin-modal__add-student' onClick={() => addStudent()}>Add Student</div>
                                    </div>
                :
                <div className='student-onboarding-card-modal-2023__subtask__wrapper'>
                    {openWorkflowModal2023.todoSubtasks.map((subtask) => <Subtask2023 key={subtask.subtaskId} subtask={subtask} setOpenModal2023={setOpenWorkflowModal2023} />)}
                    <div className='student-onboarding-card-modal-2023__add-subtask' onClick={() => setOpenWorkflowModal2023({...openWorkflowModal2023, todoSubtasks: [...openWorkflowModal2023.todoSubtasks, freshSubtask()]})}>+ Add Subtask</div>
                    <div className='student-onboarding-card-modal-2023__subtask__toggle-switch'>
                        <WebsiteInquiryCallSwitch label={'Have Courtney Call:'} input={openWorkflowModal2023.todoAlarm} setToggle={changeAlarm} />
                        <WebsiteInquiryCallSwitch label={'Called:'} input={openWorkflowModal2023.theyHaveBeenCalled} setToggle={changeTheyHaveBeenCalled} />
                    </div>
                </div>
                }
            </div>
        </div>
    )
}
export default StudentOnboardingCardModal2023;